import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from "react-redux";
import { AppActionCreators, IApplicationState, IChainEndDeclineRatioResponse, ReportActionCreators } from '@nkr/store/index';
import { IChainEndDeclineRatio } from '@nkr/models/index';
import { GridApi, ColumnApi, GridReadyEvent, FirstDataRenderedEvent } from 'ag-grid-community';
import { Button, FormControl } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';
import Grid from './grid';

interface IOwnProps {
    isCenterLogin: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getChainEndDeclineRatio: (minimumChainStarts: number) => Promise<IChainEndDeclineRatioResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    data: IChainEndDeclineRatio[],
    centerId: number,
    suppress: boolean,
    mininumChainStarts: string
}

class ChainEndDeclineRatio extends React.Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        centerId: 0,
        suppress: true,
        mininumChainStarts: '0'
    }

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let { mininumChainStarts } = this.state;

        this.props.showLoading('Getting chain end decline ratios, one moment please...').then(() => {
            this.props.getChainEndDeclineRatio(parseInt(mininumChainStarts)).then(response => {
                this.setState({
                    data: response.data.results
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    getTotals = (data: IChainEndDeclineRatio[]): IChainEndDeclineRatio => {
        let totalChipDeclines = _.sumBy(data, item => item.chipDeclines);
        let totalAdpStarts = _.sumBy(data, item => item.adpStarts);
        let totalNddStarts = _.sumBy(data, item => item.nddStarts);
        let totalChainStarts = _.sumBy(data, item => item.chainStarts);
        let wlpOffers = _.sumBy(data, item => item.wlpOffers);
        let wlpDeclines = _.sumBy(data, item => item.wlpDeclines);
        let totalDeclineRatio = totalChainStarts > 0 ? Math.round((totalChipDeclines / totalChainStarts) * 100) : 0;
        let declineRatio = wlpOffers > 0 ? Math.round((wlpDeclines / wlpOffers) * 100) : 0;

        return {
            centerId: 0,
            centerAlias: 'Totals',
            isParticipant: false,
            chipDeclines: totalChipDeclines,
            adpStarts: totalAdpStarts,
            nddStarts: totalNddStarts,
            chainStarts: totalChainStarts,
            wlpOffers: wlpOffers,
            wlpDeclines: wlpDeclines,
            declineRatio: declineRatio,
            storedDeclineRatio: 0,
            calculatedDeclineRatio: totalDeclineRatio,
            rank: 0,
        };
    }

    handleChainStartChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            mininumChainStarts: e.currentTarget.value
        });
    }

    handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            centerId: parseInt(e.currentTarget.value)
        });
    }

    handleSuppressToggle = () => {
        this.setState({
            suppress: !this.state.suppress
        });
    }

    handleSubmit = () => {
        this.getData();
    }

    handleExport = () => {
        this.gridApi.exportDataAsExcel({
            // processCellCallback(params:ProcessCellForExportParams) {
            //     const value = params.value
            //     return value === undefined ? '' : `_${value}_`
            // },
        });
    }

    render = () => {
        const filteredData = this.state.data.filter(x => {
            let center = this.state.centerId > 0 ? x.centerId == this.state.centerId : true;
            let suppress = this.state.suppress ? x.isParticipant == true : true;

            return center && suppress;
        });

        const filteredCenterList = this.state.data.filter(x => {
            if (this.state.suppress) {
                return x.isParticipant == true;
            }

            return true;
        })

        const centerList = _.sortBy(_.uniqBy(filteredCenterList.map(item => {
            return { id: item.centerId, alias: item.centerAlias };
        }), item => item.id), item => item.alias);

        const totals = this.getTotals(filteredData);

        const enableSubmit = Utility.isNumber(this.state.mininumChainStarts);

        return (
            <>
                {this.props.isCenterLogin == false && (
                    <div className='well well-sm' style={{ marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: 'center', fontSize: 14 }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ marginRight: 5 }}>Center:</div>
                                <div style={{ marginRight: 20 }}>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.centerId}
                                        onChange={this.handleCenterChange}>
                                        <option value={0}>- All Centers -</option>
                                        {centerList.map(center =>
                                            <option key={`ctr-${center.id}`} value={center.id}>{center.alias}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>

                            <div style={{ marginLeft: 20 }}>
                                <Button style={{ width: 180 }} bsStyle={this.state.suppress ? 'primary' : null} onClick={this.handleSuppressToggle}>{this.state.suppress ? 'Member Centers Only' : 'All Centers'}</Button>
                            </div>
                        </div>

                        <div>
                            <Button onClick={this.handleExport}>Export to CSV</Button>
                        </div>
                    </div>
                )}

                <Grid
                    data={filteredData}
                    totals={totals}
                    onGridReady={this.onGridReady} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getChainEndDeclineRatio: (minimumChainStarts) => {
            return dispatch(ReportActionCreators.getChainEndDeclineRatio(minimumChainStarts));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(ChainEndDeclineRatio);